import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { StorageAdapter } from '../utils/AsyncStorage'

interface FooterButtonsState {
    showMapButton: boolean
    showCreatePosButton: boolean
    setShowMapButton: (show: boolean) => void
    setShowCreatePosButton: (show: boolean) => void
    resetFooterButtons: () => void
}

export const useFooterButtonsStore = create<FooterButtonsState>()(
    persist(
        (set) => ({
            showMapButton: false,
            showCreatePosButton: false,
            setShowMapButton: (show: boolean) => set({ showMapButton: show }),
            setShowCreatePosButton: (show: boolean) => set({ showCreatePosButton: show }),
            resetFooterButtons: () => set({ showMapButton: false, showCreatePosButton: false }),
        }),
        {
            name: 'footer-buttons-storage',
            storage: createJSONStorage(() => ({
                getItem: async (name: string) => {
                    const value = await StorageAdapter.getItem(name)
                    return value ? value : null
                },
                setItem: async (name: string, value: string) => {
                    await StorageAdapter.setItem(name, value)
                },
                removeItem: async (name: string) => {
                    await StorageAdapter.removeItem(name)
                },
            })),
        },
    ),
)
